/** @jsx jsx */
import React, { useState } from "react"
import { useResultsInteriorQuery } from '../../hooks/use-results-interior-query'
import { useResultsQuery } from '../../hooks/use-results-query'
import styled from '@emotion/styled/macro'
import { css, jsx } from '@emotion/react'
import { Theme2, Device } from "../Layout"
import { WhiteCheckMark, LeftRedArrow, RightRedArrow } from "../SVGs"


const AmountSubHeadingContainer = styled.div`

text-align: left;
display: grid;
grid-template-columns: 22px auto;
grid-column-gap: 17px;
align-items: center;
padding: 15px 50px;

:hover{
  color: ${Theme2.colors.dark1};
  background-color: ${Theme2.colors.light2};
}
`
const InteriorAmount = styled.div`
font-size: 23px;
font-weight: 500;

@media ${Device.md}{
  font-size: 37px;
}
`
const InteriorSubHeading = styled.div`
text-transform: uppercase;
font-family: ${Theme2.fonts.headings};
font-size: 13px;
`

const ResultsHome = styled.div`

@media ${Device.lg}{
  border: 3px solid ${Theme2.colors.light2};
  display: grid;
  grid-template-columns: 1fr 3fr;
}

.mobile{
  @media ${Device.lg}{
    display: none;
  }
  
}
.desktop{
  display: none;
  @media ${Device.lg}{
    display: block;
    padding: 3rem;
  }
}
.resultsInnerContainer{
  border: 3px solid ${Theme2.colors.light2};
  margin-bottom: 15px;
  @media ${Device.lg}{
    margin-bottom: 0;
    display: grid;
    align-items: center;
  }
  @media ${Device.lg}{
  &:hover{
      background-color: ${Theme2.colors.light};
      margin: -0px -18px;
      box-shadow: 0px 0px 25px 0px rgba(0,0,0,.14);
      border: none;
      cursor: pointer;

      .accordionUpper{
        background-color: ${Theme2.colors.light};
      }
    }
  }
  .mobile{
  padding: 0 1.5rem;
  margin: 0 auto;
  font-size: 16px;
  }
 
  
}
.resultsInnerContainer.current{
  @media ${Device.lg}{
    background-color: ${Theme2.colors.light};
      margin: -0px -18px;
      box-shadow: 0px 0px 25px 0px rgba(0,0,0,.14);
      border: none;
      cursor: pointer;

      .accordionUpper{
        background-color: ${Theme2.colors.light};
      }
  }
      
    }
 
   
   
a{
    margin-bottom: 15px;
    display: inline-block;
    text-transform: uppercase;
    background-color: ${Theme2.colors.dark1};
    color: ${Theme2.colors.light};
    padding: 20px 33px;
    font-size: 13px;
    font-weight: 600;

    &:hover{
      background-color: ${Theme2.colors.tertiary};
    }
  }
.largerText{
    font-family: ${Theme2.fonts.headings};
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;

    @media ${Device.lg}{
      font-size: calc(24px + 21 * ((100vw - 992px) / 508));
    }
    @media (min-width: 1500px){
      font-size: 45px;
    }
  }
.accordionUpper{
  display: grid;
  grid-template-columns: 64px auto 40px;
  align-items: center;
  
  

svg{
justify-self: center;
}
button{
  appearance: none;
  background-color: transparent;
  border: none;

  @media ${Device.lg}{
    display: none;
  }
}
.amount{
font-weight: 500;
font-size: 29px;
margin: 20px 0 0 0;
}
.subHeading{
font-family: ${Theme2.fonts.headings};
font-size: 13px;
margin: 0 0 20px 0;
line-height: 1.5;
}
}
.leftDesktopOuter{
@media ${Device.lg}{
background-color: ${Theme2.colors.light2};
padding: 10px;
display: grid;
}
}
.leftDesktopInner{
@media ${Device.lg}{
  border: 2px solid ${Theme2.colors.light};
  display: grid;
  align-items: stretch;
}
}
`  

  const GetcriminalDefenseResultsList = () => {
    const criminalDefenseResultsList = [];
    const cases = useResultsInteriorQuery();
    
    cases.criminalDefense.edges.forEach((caseEdge) => {
      
        criminalDefenseResultsList.push({
          caseResultsAmount: caseEdge.node.advancedcustomfieldscaseresults.caseResultsAmount,
          caseResultsSubtitle: caseEdge.node.advancedcustomfieldscaseresults.caseResultsSubtitle,
          caseResultsTabContent: caseEdge.node.advancedcustomfieldscaseresults.caseResultsTabContent
        });
      
      
    });
  
    return criminalDefenseResultsList
    };
    const GetpersonalInjuryResultsList = () => {
      const personalInjuryResultsList = [];
      const cases = useResultsInteriorQuery();
      
      cases.personalInjury.edges.forEach((caseEdge) => {
        
          personalInjuryResultsList.push({
            caseResultsAmount: caseEdge.node.advancedcustomfieldscaseresults.caseResultsAmount,
            caseResultsSubtitle: caseEdge.node.advancedcustomfieldscaseresults.caseResultsSubtitle,
            caseResultsTabContent: caseEdge.node.advancedcustomfieldscaseresults.caseResultsTabContent
          });
        
        
      });
    
      return personalInjuryResultsList
      };
      const GetfamilyLawResultsList = () => {
        const familyLawResultsList = [];
        const cases = useResultsInteriorQuery();
        
        cases.familyLaw.edges.forEach((caseEdge) => {
          
            familyLawResultsList.push({
              caseResultsAmount: caseEdge.node.advancedcustomfieldscaseresults.caseResultsAmount,
              caseResultsSubtitle: caseEdge.node.advancedcustomfieldscaseresults.caseResultsSubtitle,
              caseResultsTabContent: caseEdge.node.advancedcustomfieldscaseresults.caseResultsTabContent
            });
          
          
        });
      
        return familyLawResultsList
        };





const CheckMarkToggle = ({cases, index}) => {

  const [hovered, setHovered] = useState(0);

  return (
    <AmountSubHeadingContainer key={index}
    onMouseOver={() =>{ 
    
      setHovered(!hovered)
     }}
    onMouseLeave={() => {
     
     setHovered(0);
     }}>
      {hovered === 0 
     ?
     <>
      <div>
      <WhiteCheckMark color={Theme2.colors.light} />
      </div>
      <div>
      <InteriorAmount>{cases.caseResultsAmount}</InteriorAmount>
    <InteriorSubHeading>{cases.caseResultsSubtitle}</InteriorSubHeading>
      </div>
      </>
:
<>
      <div>
      <WhiteCheckMark color={Theme2.colors.dark1} />
      </div>
      <div>
      <InteriorAmount>{cases.caseResultsAmount}</InteriorAmount>
    <InteriorSubHeading>{cases.caseResultsSubtitle}</InteriorSubHeading>
      </div>
      </>
      }
      
    </AmountSubHeadingContainer>
  );
}

const CriminalDefense = () => {
  const criminalDefenseResultsList = GetcriminalDefenseResultsList();
  
  return(
    <>
    {criminalDefenseResultsList.map((cases) => (
      <CheckMarkToggle cases={cases} />
    ))}
    </>
  )
}
const PersonalInjury = () => {
  const personalInjuryResultsList = GetpersonalInjuryResultsList();
  return(
    <>
    {personalInjuryResultsList.map((cases) => (
        <CheckMarkToggle cases={cases} />
      ))}
    </>
  )
}
const FamilyLaw = () => {
  const familyLawResultsList = GetfamilyLawResultsList();
  return(
    <>
    {familyLawResultsList.map((cases) => (
        <CheckMarkToggle cases={cases} />
      ))}
    </>
  )
}
const CriminalDefenseHome = () => {
  const [divClicked, setDivClicked] = useState(false)
  const [divClicked2, setDivClicked2] = useState(false)
  const [divClicked3, setDivClicked3] = useState(0)
  const [innerHTML, setInnerHTML] = useState(0)
  const cases = useResultsInteriorQuery();
  const criminalDefenseResultsList = GetcriminalDefenseResultsList();
  return(
    <ResultsHome>
      <div className="leftDesktopOuter">
        <div className="leftDesktopInner">
    {criminalDefenseResultsList.map((cases, i) => (
      <div className={`resultsInnerContainer ${divClicked3 === i ? 'current' : null}`} onClick={() => {setDivClicked(true); setInnerHTML(cases.caseResultsTabContent);  setDivClicked2(divClicked2 === i ? false : i)}} onMouseEnter={() =>{setDivClicked(true);setInnerHTML(cases.caseResultsTabContent); setDivClicked3(divClicked3 === i ? false : i)}}>
        <div className="accordionUpper" css={css`
        background-color: ${divClicked2 === i ? 'transparent' : Theme2.colors.light2};
        `}>
        <WhiteCheckMark color={Theme2.colors.dark1} />  
<div>
<p className="amount">{cases.caseResultsAmount}</p>
      <p className="subHeading">{cases.caseResultsSubtitle}</p>
</div>
<button>{divClicked2 === i ? <LeftRedArrow /> : <RightRedArrow />}</button>
        </div>
      
      <div className="mobile">
      {divClicked2 === i ? <><div dangerouslySetInnerHTML={{__html: cases.caseResultsTabContent}} />
      </> : <div style={{display: 'none'}} dangerouslySetInnerHTML={{__html: cases.caseResultsTabContent}} />}
      </div>
      </div>
    ))}
    </div>
    </div>
    <div className="desktop">
    {divClicked ? <><div dangerouslySetInnerHTML={{__html: innerHTML}} />
      </> : <><div dangerouslySetInnerHTML={{__html: cases.criminalDefense.edges[0].node.advancedcustomfieldscaseresults.caseResultsTabContent}} />
      </>}
      </div>
    </ResultsHome>
  )
}
const PersonalInjuryHome = () => {
  const [divClicked, setDivClicked] = useState(false)
  const [divClicked2, setDivClicked2] = useState(false)
  const [divClicked3, setDivClicked3] = useState(0)
  const [innerHTML, setInnerHTML] = useState(0)
  const cases = useResultsInteriorQuery();
  const personalInjuryResultsList = GetpersonalInjuryResultsList();
  return(
    <ResultsHome>
      <div className="leftDesktopOuter">
<div className="leftDesktopInner">
    {personalInjuryResultsList.map((cases, i) => (
       <div className={`resultsInnerContainer ${divClicked3 === i ? 'current' : null}`} onClick={() => {setDivClicked(true); setInnerHTML(cases.caseResultsTabContent);  setDivClicked2(divClicked2 === i ? false : i)}} onMouseEnter={() =>{setDivClicked(true);setInnerHTML(cases.caseResultsTabContent); setDivClicked3(divClicked3 === i ? false : i)}}>
        <div className="accordionUpper" css={css`
        background-color: ${divClicked2 === i ? 'transparent' : Theme2.colors.light2};
        `}>
        <WhiteCheckMark color={Theme2.colors.dark1} />  
<div>
<p className="amount">{cases.caseResultsAmount}</p>
      <p className="subHeading">{cases.caseResultsSubtitle}</p>
</div>
<button>{divClicked2 === i ? <LeftRedArrow /> : <RightRedArrow />}</button>
        </div>
        <div className="mobile">
        {divClicked2 === i ? <><div dangerouslySetInnerHTML={{__html: cases.caseResultsTabContent}} />
      </> : <div style={{display: 'none'}} dangerouslySetInnerHTML={{__html: cases.caseResultsTabContent}} />}
      </div>
        </div>
      ))}
      </div>
</div>
      <div className="desktop">
      {divClicked ? <><div dangerouslySetInnerHTML={{__html: innerHTML}} />
      </> : <><div dangerouslySetInnerHTML={{__html: cases.personalInjury.edges[0].node.advancedcustomfieldscaseresults.caseResultsTabContent}} />
      </>}
      </div>
    </ResultsHome>
  )
}
const FamilyLawHome = () => {
  const [divClicked, setDivClicked] = useState(false)
  const [divClicked2, setDivClicked2] = useState(false)
  const [divClicked3, setDivClicked3] = useState(0)
  const [innerHTML, setInnerHTML] = useState(0)
  const cases = useResultsInteriorQuery();
  const familyLawResultsList = GetfamilyLawResultsList();
  return(
    <ResultsHome>
      <div className="leftDesktopOuter">
<div className="leftDesktopInner">
    {familyLawResultsList.map((cases, i) => (
       <div className={`resultsInnerContainer ${divClicked3 === i ? 'current' : null}`} onClick={() => {setDivClicked(true); setInnerHTML(cases.caseResultsTabContent);  setDivClicked2(divClicked2 === i ? false : i)}} onMouseEnter={() =>{setDivClicked(true);setInnerHTML(cases.caseResultsTabContent); setDivClicked3(divClicked3 === i ? false : i)}}>
         <div className="accordionUpper" css={css`
        background-color: ${divClicked2 === i ? 'transparent' : Theme2.colors.light2};
        `}>
        <WhiteCheckMark color={Theme2.colors.dark1} />  
<div>
<p className="amount">{cases.caseResultsAmount}</p>
      <p className="subHeading">{cases.caseResultsSubtitle}</p>
</div>
<button>{divClicked2 === i ? <LeftRedArrow /> : <RightRedArrow />}</button>
        </div>
        <div className="mobile">
        {divClicked2 === i ? <><div dangerouslySetInnerHTML={{__html: cases.caseResultsTabContent}} />
      </> : <div style={{display: 'none'}} dangerouslySetInnerHTML={{__html: cases.caseResultsTabContent}} />}
      </div>
        </div>
      ))}
      </div>
</div>
      <div className="desktop">
      {divClicked ? <><div dangerouslySetInnerHTML={{__html: innerHTML}} />
      </> : <><div dangerouslySetInnerHTML={{__html: cases.familyLaw.edges[0].node.advancedcustomfieldscaseresults.caseResultsTabContent}} />
      </>}
      </div>
    </ResultsHome>
  )
}
const ResultsInterior = ({data2, resultsTabTitle}) => {
  const cases = data2;
  const activeTab = resultsTabTitle;
  const resultsQuery = useResultsQuery()
  
if(cases === "criminal-defense"){
  return(
    <>
    <CriminalDefense />
    <div style={{display: 'none'}}>
    <PersonalInjury />
    <FamilyLaw />
    </div>
    </>
  )
  }
  else if(cases === "personal-injury"){
    return(
      <PersonalInjury />
    )
    }
    else if(cases === "family-law"){
      return(
        <FamilyLaw />
      )
      }
      else if(activeTab === "Criminal Defense"){
        return(
          <>
          <div className="tabParagraph" dangerouslySetInnerHTML={{ __html: resultsQuery.resultsTabs[0].resultsTabParagraph }} />
          <div style={{display: 'none'}}>
          <div dangerouslySetInnerHTML={{ __html: resultsQuery.resultsTabs[1].resultsTabParagraph }} />
          <div dangerouslySetInnerHTML={{ __html: resultsQuery.resultsTabs[2].resultsTabParagraph }} />
          </div>
          <CriminalDefenseHome />
          <div style={{display: 'none'}}>
          <PersonalInjuryHome />
          <FamilyLawHome />
          </div>
          </>
        )
        }
        else if(activeTab === "Personal Injury"){
          return(
            <>
            <div className="tabParagraph" dangerouslySetInnerHTML={{ __html: resultsQuery.resultsTabs[1].resultsTabParagraph }} />
            <PersonalInjuryHome />
            </>
          )
          }
          else if(activeTab === "Family Law"){
            return(
              <>
              <div className="tabParagraph" dangerouslySetInnerHTML={{ __html: resultsQuery.resultsTabs[2].resultsTabParagraph }} />
              <FamilyLawHome />
              </>
            )
            }
  else{
  return(
    null
  )
}





};

export { ResultsInterior, CriminalDefense, PersonalInjury, FamilyLaw }